import { type DOMAINS } from '~/domains/core';
import { domainConfig } from '../config/domainConfig.ts';
import { getCurrentDomain } from './getCurrentDomain.ts';

interface GetCurrentConfigByDomainReturn {
  currentDomain: keyof typeof DOMAINS;
  currentConfig: ReturnType<
    typeof domainConfig
  >['config'][keyof typeof DOMAINS];
  defaultConfig: ReturnType<typeof domainConfig>['defaultConfig'];
}

export const getCurrentConfigByDomain = (
  hostname: string,
): GetCurrentConfigByDomainReturn => {
  const currentDomain = getCurrentDomain(hostname);
  const { config, defaultConfig } = domainConfig();
  const currentConfig = config[currentDomain] ?? defaultConfig;

  return {
    currentDomain,
    currentConfig,
    defaultConfig,
  };
};
